import { render, staticRenderFns } from "./WorldViewList.vue?vue&type=template&id=50f38167&scoped=true"
import script from "./WorldViewList.vue?vue&type=script&lang=ts"
export * from "./WorldViewList.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewList.vue?vue&type=style&index=0&id=50f38167&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f38167",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f38167')) {
      api.createRecord('50f38167', component.options)
    } else {
      api.reload('50f38167', component.options)
    }
    module.hot.accept("./WorldViewList.vue?vue&type=template&id=50f38167&scoped=true", function () {
      api.rerender('50f38167', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/WorldViewList.vue"
export default component.exports